import { getLandingContent } from "../../data/landingContent";

export function SocialIntentSection() {
  const { socialIntent } = getLandingContent();

  return (
    <section className="st-section" style={{ background: "var(--gray-light)" }} aria-label="Target search scenarios">
      <div className="st-container" style={{ textAlign: "center", marginBottom: "36px" }}>
        <h2 className="st-heading-2">
          {socialIntent.title}
        </h2>
        <p className="st-body-large" style={{ maxWidth: "600px", margin: "0 auto" }}>
          {socialIntent.subtitle}
        </p>
      </div>
      <div className="st-container">
        <div className="st-social-intent-grid">
          {socialIntent.cards.map((card, i) => (
            <article 
              key={i} 
              className={`st-social-intent-card ${i === 0 ? "highlighted" : ""}`}
            >
              <h3>
                {card.title}
              </h3>
              <p>
                {card.text}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
